import { render } from "./AddTariffZone.vue?vue&type=template&id=190b4f54&ts=true"
import script from "./AddTariffZone.vue?vue&type=script&lang=ts"
export * from "./AddTariffZone.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__